import { CloudActions } from '@portal/portal-core';
import * as Types from '../types';

interface AcceptInviteResult {
  open?: boolean;
  success?: boolean;
  result?: unknown;
}

export interface UserInvitesState {
  invites: unknown[];
  acceptInviteResult: AcceptInviteResult;
}

interface InvitesSyncPayload {
  invites: unknown[];
}

interface AcceptInvitePayload {
  open?: boolean;
  success?: boolean;
  result?: unknown;
}

export const initialState: UserInvitesState = { invites: [], acceptInviteResult: {} };

export function UserInvites(
  state: UserInvitesState = initialState,
  action: { type: string; payload?: unknown },
): UserInvitesState {
  const { payload } = action;
  switch (action.type) {
    case Types.CLIENT_INVITES_SYNC:
      return { ...state, invites: (payload as InvitesSyncPayload).invites };
    case Types.CLIENT_ACCEPT_INVITE_RESULT: {
      const { open, success, result } = payload as AcceptInvitePayload;
      return {
        ...state,
        acceptInviteResult: {
          open,
          success,
          result,
        },
      };
    }
    case Types.CLIENT_ACCEPT_INVITE_RESULT_CLEAR:
      return { ...state, acceptInviteResult: {} };
    case CloudActions.LOGOUT:
      return initialState;
    default:
      return state;
  }
}
